import * as React from 'react';

import Coach from 'components/atoms/Coach';
import i18n from 'helper/i18n';
import { CoachIsEnumType } from '../../CoachSelector/CoachSelector';

export const BoardFeedbackLevel = {
	perfect: 'PERFECT',
	goodWork: 'GOOD_WORK',
	getStarted: 'GET_STARTED',
};

export type BoardFeedbackProps = {
	level?: any;
	coach?: CoachIsEnumType;
};

const BoardFeedback = ({ level, coach }: BoardFeedbackProps) => (
	<div className="m-board-feedback">
		<div className="m-board-feedback__info">
			<h2 className="m-board-feedback__title">
				{i18n(`react.impulsCoach.molecules.BoardFeedback.${level || 'FALLBACK'}.title`)}
			</h2>
			<p className="m-board-feedback__text">
				{i18n(`react.impulsCoach.molecules.BoardFeedback.${level || 'FALLBACK'}.text`)}
			</p>
		</div>
		<div className="m-board-feedback__coach-box">
			<div className="m-board-feedback__coach-wrap">
				<Coach coach={coach ? coach : 'LEO'} gesture="front-top" alt="" />
			</div>
		</div>
	</div>
);

export default BoardFeedback;
